
import OrderService from "@/services/order.service.js";

export default class DefaultExpectedShippingDateUsecase {
  constructor () {
    this.orderService = new OrderService();
  }

  async getDefaultExpectedShippingDate () {
    const res = await this.orderService.getDefaultExpectedShippingDate();
    return res;
  }
}
